import { ValidateResult } from "react-hook-form";

import { ValidationFailure } from "../validation/ValidationResult";

export const mapFailuresToValidateResult = (failures: ValidationFailure[]): ValidateResult => JSON.stringify(failures);
